import {createContext} from "react";

// This context stores the current position in the stack.
const StackPositionContext = createContext();

export default StackPositionContext;
